import DraggableScrollArea from "@/components/DraggableScrollArea";
import useCurrentUser from "@/hooks/useCurrentUser";
import { StarIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import Image from "next/image";
import RecipeThumbnail from "@/src/recipes/components/Thumbnail";

const colourways = ["rust", "violet", "teal", "red"];

const RecipeCarousel = ({ recipes }) => {
  return (
    <div className={clsx("rounded-lg bg-yellow py-[60px] pl-6")}>
      <DraggableScrollArea>
        <div className={clsx("flex w-full gap-6")}>
          {recipes.map((recipe, index) => {
            return (
              <div className={`flex w-[260px] gap-6 rounded-lg`}>
                <RecipeThumbnail noHover entry={recipe} disableLink />
              </div>
            );
          })}
        </div>
      </DraggableScrollArea>
    </div>
  );
};

export default RecipeCarousel;
